import React from 'react';
import _get from 'lodash/get';
import _map from 'lodash/map';
import { COMMON_PAGE_DATA } from './config';

class Faq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      faqState: ''
    };
    this.ref = React.createRef();
    const {
      images: { banner_store_desktop = '', banner_store_mobile = '' }
    } = COMMON_PAGE_DATA;
    const imgUrl = innerWidth > 500 ? banner_store_desktop : banner_store_mobile;
    this.footerImage = {
      backgroundImage: `url(${imgUrl})`
    };
  }

  showPincodeModalForFAQSection = event => {
    event.preventDefault();
    this.props.indexStatesProps.showPincodeModal('');
  };

  handleEvent = event => {
    event.target.className.includes('show-pincode-modal') === true &&
      this.showPincodeModalForFAQSection(event);
  };

  componentDidMount() {
    const { observer = {} } = this.props;
    observer.observe(this.ref.current);
    this.ref.current.addEventListener('click', this);
  }

  componentWillUnmount() {
    this.ref.current.removeEventListener('click', this);
  }

  setFaqState = key => () => {
    const { faqState } = this.state;
    this.setState({ faqState: faqState !== key ? key : '' });
  };

  render() {
    const { content: { headerText = '' } = {} } = this.props.data;
    const { faqState } = this.state;
    const storePickupFaq = _get(this.props, 'faqAndTestimonial.faq', []);
    const {
      content: { checkAvailabilityText = '' }
    } = COMMON_PAGE_DATA;
    return (
      <div className="storePickup" id="faq" ref={this.ref} style={this.footerImage}>
        <div className="heading1">{headerText}</div>
        <div className="faq-questions">
          {_map(storePickupFaq, (faq = {}, index) => (
            <div
              className={`faq-accordion${faqState === index ? ' faq-accordion-open' : ''}`}
              key={faq.question}
            >
              <div className="collapsible" onClick={this.setFaqState(index)}>
                <span>{faq.question}</span>
                <span className={`${faqState === index ? 'ic-angle-up' : 'ic-angle-down'}`} />
              </div>
              <div className={`accordion-content ${faqState === index ? ' accordion-show' : ''}`}>
                <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
              </div>
            </div>
          ))}
          <div className="check-availability">
            <a href="#banner">{checkAvailabilityText}</a>
          </div>
        </div>
      </div>
    );
  }
}

export default Faq;
